import React, { FC, memo } from 'react';
import styled from 'styled-components';
import Button from '@minecraft.button';
import { useTranslation } from '@blocs.i18n';

export const HelperText = styled.div`
  font-size: 0.8rem;
  font-style: italic;
  text-align: left;
  margin-bottom: 1.25rem;
  width: 100%;

  & > * {
    vertical-align: middle;
  }
`;

export const HelperTextUser = styled.span`
  border-right: 0.0625rem solid ${(props): string => props.theme.colors.primary.ltGrey1};
  font-weight: 600;
  font-style: normal;
  padding-right: 0.5rem;
  margin-right: 0.5rem;
`;

export const StyledUserNameButton = styled(Button)`
  font-style: inherit;
  padding: 0;
  min-width: auto;
  height: auto;

  &,
  &:hover {
    color: ${(props): string => props.theme.colors.primary.primary};
    text-decoration: none;
  }
`;

type Props = {
  userName?: string;
  handleUserNameModalToggle: () => void;
  helpText?: string;
  helpTextWithName?: string;
};

const PicksHelperText: FC<Props> = ({ userName, handleUserNameModalToggle, helpText, helpTextWithName }) => {
  const { t } = useTranslation();

  return (
    <HelperText>
      {userName ? (
        <>
          <span>{helpTextWithName || t('common:recipient.picksHelperText.helperTextWithNameDefault')}</span>
          <HelperTextUser>{userName}</HelperTextUser>
          <StyledUserNameButton role="button" color="link" onClick={handleUserNameModalToggle}>
            {t('common:recipient.picksHelperText.changeName')}
          </StyledUserNameButton>
        </>
      ) : (
        <>
          <span>{helpText || t('common:recipient.picksHelperText.helperTextDefault')}</span>
          <StyledUserNameButton role="button" color="link" onClick={handleUserNameModalToggle}>
            {t('common:recipient.picksHelperText.provideName')}
          </StyledUserNameButton>
        </>
      )}
    </HelperText>
  );
};

export default memo(PicksHelperText);
